import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col } from 'react-bootstrap';
import ChannelService from '@avtechsoftware/ra-javascript-utilities/src/utilities/channels/ChannelService';
import { useDispatch, useSelector } from 'react-redux';
import FormErrorHandler
  from '@avtechsoftware/react-component-library/src/components/common/FormErrorHandler/FormErrorHandler';
import ReadingType from '@avtechsoftware/ra-javascript-utilities/src/types/ReadingType';
import {
  AlertFormSteps,
  selectSensorsData,
  selectThresholdData,
  updateStepData,
} from '../../../../redux/slices/alertFormSlice/alertFormSlice';
import { parseChannelKey } from '../../../../utility/channelUtils';
import IndependentThresholdInput from './IndependentThresholdInput';

function NewIndependentThresholdForm(props) {
  const dispatch = useDispatch();
  const { selectedChannels, readingType } = useSelector(selectSensorsData);
  const thresholdData = useSelector(selectThresholdData);
  const { disabled, cloneToSharedEnabled, cloneIndependentToShared } = props;

  const handleThresholdValueChange = (value) => {
    const numericValue = parseFloat(value);
    dispatch(updateStepData({
      step: AlertFormSteps.DEFINE_THRESHOLD,
      data: { thresholdValue: Number.isNaN(numericValue) ? null : numericValue },
    }));
  };

  const handleOperatorChange = (value) => {
    dispatch(updateStepData({
      step: AlertFormSteps.DEFINE_THRESHOLD,
      data: { thresholdOperator: value },
    }));
  };

  const { channelGroupType, channelIndex, channelType } = parseChannelKey(
    selectedChannels[0],
  );
  const channel = ChannelService
    .getChannelGroupChannel(channelGroupType, channelIndex, channelType);

  return (
    <FormErrorHandler
      fieldList={['name', 'value', 'readingType']}
      errorList={thresholdData.errorList}
    >
      <div
        style={{
          opacity: disabled ? 0.5 : 1,
          pointerEvents: disabled ? 'none' : 'auto',
        }}
        className="ml-3 mt-2"
      >
        <div className="d-flex align-items-start flex-wrap">
          <div className="mr-2 mb-1">
            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <select
              className="form-control w-auto"
              defaultValue={channel.displayName}
              disabled
            >
              <option>{channel.displayName}</option>
            </select>
          </div>
          <Col xs="auto" className="form-group mb-1">
            <IndependentThresholdInput
              channel={channel}
              thresholdValue={thresholdData.thresholdValue}
              setThresholdValue={handleThresholdValueChange}
              operator={thresholdData.thresholdOperator}
              setOperator={handleOperatorChange}
              errorList={thresholdData.errorList}
            />
          </Col>
          {cloneToSharedEnabled && readingType != null
              && readingType !== ReadingType.GENERIC_BOOLEAN.id && (
              <Col xs="auto" className="form-group mb-1">
                {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                <Button
                  variant="secondary"
                  onClick={cloneIndependentToShared}
                >
                  Make this a shared threshold
                </Button>
              </Col>
          )}
        </div>
      </div>
    </FormErrorHandler>
  );
}

NewIndependentThresholdForm.propTypes = {
  disabled: PropTypes.bool.isRequired,
  cloneToSharedEnabled: PropTypes.bool.isRequired,
  cloneIndependentToShared: PropTypes.func.isRequired,
};

export default NewIndependentThresholdForm;
